import { useState } from 'react';
import '../styles/styles.scss';
import Main from './Main';
import Layout from '@sleepunique/components/global/Layout';
import ErrorBoundary from '@components/_global/ErrorBoundary';
import Providers from '@sleepunique/components/global/Providers';

const App = () => (
  <Providers>
    <ErrorBoundary>
      <Layout className="sleepunique-app">
        <Main />
      </Layout>
    </ErrorBoundary>
  </Providers>
);

export default App;
